import { getInstance } from "@/api/instance";
import { app } from "@/main";

// action types
export const GET_SERVICE = "getService";
export const SET_ERROR = "setError";

// mutation types
export const UPDATE_SERVICE = "updateService";

const state = {
  errors: null,
  services: [],
};

const getters = {
  currentServices(state) {
    return state.services;
  },
};

const actions = {
  [GET_SERVICE](context, payload) {
    return new Promise((resolve, reject) => {
      getInstance("SERVICE", payload)
        .then((data) => {
          context.commit(UPDATE_SERVICE, data);
          resolve(data);
        })
        .catch((error) => {
          context.commit(SET_ERROR, error);
          reject(error);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [UPDATE_SERVICE](state, services) {
    const nowTimestamp = app.$moment().unix();
    services.result.forEach((item) => {
      if (item.date_of_expiry > nowTimestamp) {
        const serviceDate = app.$moment.unix(item.date_of_expiry);
        const days = serviceDate.diff(app.$moment(), "days");
        item.status = days + "天后到期";
        item.class = "success";
      } else {
        item.status = "已过期";
        item.class = "Danger";
      }
    });
    state.services = services.result;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
